import React from 'react';
import './AvAligner.css';

const HUGGING_FACE_SPACE_URL =
  'https://huggingface.co/spaces/paarth-a/AV-alignment';
const HUGGING_FACE_EMBED_URL =
  'https://paarth-a-av-alignment.hf.space';

const AvAligner: React.FC = () => (
  <div className="av-aligner av-aligner--fullscreen">
    <a className="av-aligner__back-link" href="/">
      ← Back to paarth-a.github.io
    </a>
    <iframe
      src={HUGGING_FACE_EMBED_URL}
      title="Video Audio Alignment"
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </div>
);

export default AvAligner;
